import styled from 'styled-components';

export const clsPrefix = 'ui-card';

export const CardSC = styled.div`
  overflow: hidden;

  &.${`${clsPrefix}-small`} {
    border-radius: ${({ theme }) => theme.radius.medium}px;
  }

  &.${`${clsPrefix}-medium`} {
    border-radius: ${({ theme }) => theme.radius.large}px;
  }

  &.${`${clsPrefix}-large`} {
    border-radius: ${({ theme }) => theme.radius.extraLarge}px;
  }

  &.${clsPrefix}-elevated {
    box-shadow: ${({ theme }) => theme.shadows.low};
    background-color: ${({ theme }) => theme.color.surface.baseline};
  }

  &.${clsPrefix}-outlined {
    border-width: 1px;
    border-color: ${({ theme }) => theme.color.border.outline};
  }
`;
